import React from "react"
import DefaultLayout from "../DefaultLayout"
import { ILayoutProps } from "../types"

export function TableLayout(props: ILayoutProps) {
  return <DefaultLayout {...props} isTableLayout={true} />
}
export default TableLayout
